import { LanguagesTypes } from '@hydra/types';

function getLanguage (locale: LanguagesTypes): LanguagesTypes {
  switch (locale) {
    case 'es':
    case 'en':
      return locale;
    default:
      return 'en';
  }
}

export default function getCoreWebVitalsLink (locale: LanguagesTypes): string {
  const language = getLanguage(locale);
  return `https://www.woorank.com/${language}/core-web-vitals`;
}
